import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";
import ShoesArticle from "../pages/article-shoes/page";
import HoodiesArticle from "../pages/article-hoodies/page";
import JacketsArticle from "../pages/article-jackets/page";
import AccessoriesArticle from "../pages/article-accessories/page";
import BudgetArticle from "../pages/article-budget/page";
import TikTokArticle from "../pages/article-tiktok/page";
import QualityArticle from "../pages/article-quality/page";
import BeginnerArticle from "../pages/article-beginner/page";
import TrendingArticle from "../pages/article-trending/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-sheet-ultimate-guide",
    element: <Article />,
  },
  {
    path: "/article/pandabuy-sheet-shoes-guide",
    element: <ShoesArticle />,
  },
  {
    path: "/article/pandabuy-sheet-hoodies-guide",
    element: <HoodiesArticle />,
  },
  {
    path: "/article/pandabuy-sheet-jackets-guide",
    element: <JacketsArticle />,
  },
  {
    path: "/article/pandabuy-sheet-accessories-guide",
    element: <AccessoriesArticle />,
  },
  {
    path: "/article/pandabuy-sheet-budget-finds",
    element: <BudgetArticle />,
  },
  {
    path: "/article/pandabuy-sheet-viral-tiktok",
    element: <TikTokArticle />,
  },
  {
    path: "/article/pandabuy-sheet-quality-tips",
    element: <QualityArticle />,
  },
  {
    path: "/article/pandabuy-sheet-beginner-guide",
    element: <BeginnerArticle />,
  },
  {
    path: "/article/pandabuy-sheet-trending-2026",
    element: <TrendingArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;